/**
 * @fileoverview Capacitor plugin for syncing Supabase auth to native iOS storage
 *
 * This plugin stores the Supabase session in App Group UserDefaults so the
 * iOS share extension can access it to make authenticated API calls.
 */

import { registerPlugin } from '@capacitor/core';
import type { AuthStoragePlugin } from './AuthStoragePluginDefinitions';

const AuthStorage = registerPlugin<AuthStoragePlugin>('AuthStoragePlugin', {
  web: () => import('./AuthStoragePluginWeb').then(m => new m.AuthStoragePluginWeb()),
});

export * from './AuthStoragePluginDefinitions';
export default AuthStorage;
